__turbopack_context__.v({
  "cancelButton": "news-module__MlY1RW__cancelButton",
  "deleteButton": "news-module__MlY1RW__deleteButton",
  "editActions": "news-module__MlY1RW__editActions",
  "editButton": "news-module__MlY1RW__editButton",
  "editForm": "news-module__MlY1RW__editForm",
  "editTextarea": "news-module__MlY1RW__editTextarea",
  "fileInput": "news-module__MlY1RW__fileInput",
  "fileLabel": "news-module__MlY1RW__fileLabel",
  "formActions": "news-module__MlY1RW__formActions",
  "header": "news-module__MlY1RW__header",
  "imagePreview": "news-module__MlY1RW__imagePreview",
  "imagePreviewContainer": "news-module__MlY1RW__imagePreviewContainer",
  "loadingMessage": "news-module__MlY1RW__loadingMessage",
  "main": "news-module__MlY1RW__main",
  "page": "news-module__MlY1RW__page",
  "post": "news-module__MlY1RW__post",
  "postActions": "news-module__MlY1RW__postActions",
  "postForm": "news-module__MlY1RW__postForm",
  "postFormContainer": "news-module__MlY1RW__postFormContainer",
  "postImage": "news-module__MlY1RW__postImage",
  "postMeta": "news-module__MlY1RW__postMeta",
  "postText": "news-module__MlY1RW__postText",
  "postTextarea": "news-module__MlY1RW__postTextarea",
  "postTimestamp": "news-module__MlY1RW__postTimestamp",
  "saveButton": "news-module__MlY1RW__saveButton",
  "submitButton": "news-module__MlY1RW__submitButton",
  "thread": "news-module__MlY1RW__thread",
});
